// ═══════════════════════════════════════════════════════════════
//  渲染层级（depth）与 UI 颜色的【单一来源】
//  任何地方需要 depth / 主题色，都必须引用这里，禁止再写裸数字/裸色值。
// ═══════════════════════════════════════════════════════════════

export const DEPTH = {
  floor: -10,          // 地牢地面
  shadow: 0,
  worldLabel: 6,       // 门标签 / 玩家护盾
  fx: 70,              // 斩击 / 爆炸 特效
  fxSpark: 71,
  hudFlash: 80,        // 屏幕内飘字（击杀完成等）
  toast: 86,           // 头顶拾取提示
  bossBanner: 90,
  hud: 50,
  bossBar: 55,          // BOSS 血条（屏幕固定顶部居中）
  pauseOverlay: 100,
  pauseContent: 101,
  pauseButton: 102,
  pauseNav: 150,
  talentOverlay: 200,
  talentContent: 201,
  talentNav: 205,
  sceneNav: 5,         // 菜单/结算界面的箭头导航
} as const;

/** 主题色（语义化命名，避免同色多处硬编码） */
export const UI = {
  gold: '#f1c40f',
  red: '#e74c3c',
  green: '#2ecc71',
  blue: '#3498db',
  orange: '#e67e22',
  purple: '#9b59b6',
  text: '#ecf0f1',
  muted: '#95a5a6',
  dim: '#7f8c8d',
  danger: '#ff9b8f',
  doorUp: '#66ccff',
  doorDown: '#ffcc44',
} as const;

/** 十六进制数字色（用于 Graphics / setTint） */
export const TINT = {
  shield: 0x66ddff,
  doorLocked: 0x555555,
  doorOpen: 0x66ff88,
  fxSlash: 0xffcc66,
  fxRing: 0xffaa33,
  fxSpark: 0xffdd66,
  fxSpawn: 0xaaffaa,
  enemyBullet: 0xff8866,
  hurt: 0xff6666,
  dead: 0xff0000,
  elite: 0xffb0ff,
  boss: 0xff6666,
} as const;
